<ion-list lines="none" class="w-full flex flex-col gap-4 py-4">
  <ion-item class="input-label">
    <ion-input
      type="text"
      fill="outline"
      label="Texte du bouton"
      label-placement="floating"
      color="primary"
      [(ngModel)]="buttonText"
      (ionChange)="onInputChange()"
    ></ion-input>
  </ion-item>
  <ion-item class="input-label">
    <ion-input
      type="text"
      fill="outline"
      label="Lien du bouton"
      label-placement="floating"
      color="primary"
      [(ngModel)]="buttonLink"
      (ionChange)="onInputChange()"
    ></ion-input>
  </ion-item>
</ion-list>
